/**
 * Created by OBL on 14/01/2016.
 */
define('adminAssayController',[
    'module',
    'underscore',
    'app',
    'adminAssayView',
    'bootbox',
    'assayCreateEditLayoutView',
    'settings',
    'entities/assay'
], function(
    module,
    _,
    App,
    View,
    bootbox,
    CreateEditLayoutView
    ) {
    'use strict';

    var SuperAdminAssayListController = {
        showAssayList: function(data) {
            this.data = data;
            var view = new View({data: data});
            this.view = view;
            view.listenTo(view, 'onGridLoaded', _.bind(this.onGridLoaded, this));
            view.listenTo(view, 'assay:delete', _.bind(this.onDelete, this));
            view.listenTo(view, 'assay:edit', _.bind(this.onEdit, this));
            App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion('assayListTab').show(view);
        },

        showAssayAdd: function(mbKitSecId) {
            this.showAssayAddEdit(App.request('assay:model', {
                refKit: {
                    secId: mbKitSecId
                }
            }), true);
        },

        showAssayAddEdit: function(model, newItem) {
            this.createEditView = new CreateEditLayoutView({
                assayModel: model,
                newItem: newItem
            });
            this.createEditView.show({
                title: _.i18n('assay.new')
            });
        },

        showAssayEdit: function(mbKitSecId, assaySecId) {
            var that = this;
            var model = App.request('assay:model', {
                refKit: {
                    secId: mbKitSecId
                },
                secId: assaySecId
            });
            model.fetch().done(function() {
                that.showAssayAddEdit(model, false);
            });
        },

        onEdit: function(mbKitSecId, assaySecId){
            App.navigate('admin/kits/' + mbKitSecId + '/assay/' + assaySecId + '/edit', {trigger: true});
        },

        onGridLoaded: function() {
            var kitSecId = this.data.model.get('refKitSecId')?
                                this.data.model.get('refKitSecId'):this.data.model.get('secId');
            var data = {
                url: App.request('assay:get-collection-url', kitSecId),
                rowCountUrl: App.request('assay:get-count-url', kitSecId)
            };

            this.view.displayGrid(data);
        },

        onDelete: function(kitSecId, secId){
            bootbox.confirm(_.i18n('assay.confirmDelete'), _.bind(function(result) {
                if(result){
                    App.request('assay:delete', kitSecId, secId)
                        .done(_.bind(function(){
                            this.view.updatePagination('reloadGrid');
                        }, this));
                }
            }, this));
        }
    };

    module.exports = SuperAdminAssayListController;
});
